import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, ModalFooter, ModalHeader,
} from 'reactstrap';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { translate } from 'react-switch-lang';
import StandardButton from '../buttons/Base/StandardButton';

function ChangeableImage({
  t,
  opened,
  toggle,
  onSave,
  getUploadParams,
  handleUpload,
  cancelText,
  saveText,
  image,
  imageClassName,
}) {
  const [localOpened, setLocalOpened] = useState(false);
  const localToggle = () => {
    setLocalOpened(!localOpened);
  };

  const saveImage = () => {
    if (onSave) {
      onSave();
    }
    if (toggle) {
      toggle();
    } else {
      setLocalOpened(false);
    }
  };
  return (
    <>
      <img className={imageClassName} alt="" src={image} onClick={toggle || localToggle} />
      <Modal isOpen={opened || localOpened} toggle={toggle || localToggle}>
        <ModalHeader toggle={toggle || localToggle}>{t('users.Upload avatar')}</ModalHeader>
        <ModalBody>
          <form className="dropzone digits" id="singleFileUpload" action="/upload.php">
            <div className="dz-message needsclick">
              <Dropzone
                getUploadParams={getUploadParams}
                onChangeStatus={handleUpload}
                maxFiles={1}
                multiple
                canCancel={false}
                inputContent={t('Drop A File')}
                styles={{
                  dropzone: { width: 400, height: 200 },
                  dropzoneActive: { borderColor: 'green' },
                }}
              />
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <div className="button-group-mb-sm">
            {onSave && (
              <StandardButton
                className="btn-primary"
                onClick={saveImage}
              >
                {saveText}
              </StandardButton>
            )}
            <StandardButton
              className="btn-secondary"
              onClick={toggle || localToggle}
            >
              {cancelText}
            </StandardButton>
          </div>
        </ModalFooter>
      </Modal>
    </>
  );
}

ChangeableImage.defaultProps = {
  opened: false,
  cancelText: 'Cancel',
  saveText: 'Save',
  image: null,
  imageClassName: 'img-70 rounded-circle',
  onSave: null,
};
ChangeableImage.propTypes = {
  t: PropTypes.func.isRequired,
  opened: PropTypes.bool,
  toggle: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  getUploadParams: PropTypes.func.isRequired,
  handleUpload: PropTypes.func.isRequired,
  cancelText: PropTypes.string,
  saveText: PropTypes.string,
  imageClassName: PropTypes.string,
  image: PropTypes.oneOf([
    PropTypes.string,
    null,
  ]),
};

export default translate(ChangeableImage);
